/********************************************************************************
 * Copyright (c) 2019-2023 EclipseSource and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0 WITH Classpath-exception-2.0
 ********************************************************************************/
import { AnyObject, hasNumberProp } from '@eclipse-glsp/sprotty';

export function createElementFromHTML(html: string): HTMLElement | undefined {
    const template = document.createElement('template');
    html = html.trim(); // Never return a text node of whitespace as the result
    template.innerHTML = html;
    const node = template.content.firstChild;
    if (node && node instanceof HTMLElement) {
        return node as HTMLElement;
    }
    return undefined;
}

export function isMouseEvent(object: unknown): object is MouseEvent {
    return AnyObject.is(object) && hasNumberProp(object, 'pageX') && hasNumberProp(object, 'pageY');
}
